import {
  GRAPH_RING_BASE_RADIUS,
  GRAPH_RING_RADIUS_STEP,
  GRAPH_RING_MIN_SPACING,
} from './graphConstants';

export const getElementKey = (element) => {
  const elementId = element?.data?.id;
  if (!elementId) return null;
  return element?.data?.source || element?.data?.target ? `edge:${elementId}` : `node:${elementId}`;
};

export const getNeighborPositionForNode = (cyNode) => {
  if (!cyNode || cyNode.length === 0) {
    return null;
  }

  const connectedEdges = cyNode.connectedEdges();
  if (!connectedEdges || connectedEdges.length === 0) {
    return null;
  }

  const firstEdge = connectedEdges[0];
  const sourceId = firstEdge.source().id();
  const targetId = firstEdge.target().id();
  const nodeId = cyNode.id();
  const neighborId = sourceId === nodeId ? targetId : sourceId;

  const neighborNode = cyNode.cy().getElementById(neighborId);
  if (!neighborNode || neighborNode.length === 0) {
    return null;
  }

  return neighborNode.position();
};

export const buildRingLayoutPositions = (
  nodeElements,
  customBaseRadius = GRAPH_RING_BASE_RADIUS,
  customMinSpacing = GRAPH_RING_MIN_SPACING
) => {
  const rings = new Map();

  nodeElements.forEach((element) => {
    const nodeId = element?.data?.id;
    if (!nodeId) {
      return;
    }

    const hopValue = element?.data?.hop;
    const parsedHop = Number.parseInt(hopValue, 10);
    const ringLevel = Number.isFinite(parsedHop) && parsedHop > 0 ? parsedHop : 1;

    if (!rings.has(ringLevel)) {
      rings.set(ringLevel, []);
    }

    rings.get(ringLevel).push(element);
  });

  const positions = new Map();
  const ringLevels = Array.from(rings.keys()).sort((a, b) => a - b);

  ringLevels.forEach((ringLevel) => {
    const ringNodes = rings.get(ringLevel) || [];
    if (ringNodes.length === 0) {
      return;
    }

    const baseRadius = customBaseRadius + ((ringLevel - 1) * GRAPH_RING_RADIUS_STEP);
    const neededRadius = (ringNodes.length * customMinSpacing) / (2 * Math.PI);
    const radius = Math.max(baseRadius, neededRadius);

    ringNodes.forEach((element, index) => {
      const nodeId = element?.data?.id;
      if (!nodeId) {
        return;
      }

      const angle = (-Math.PI / 2) + ((Math.PI * 2 * index) / ringNodes.length);
      positions.set(nodeId, {
        x: Math.cos(angle) * radius,
        y: Math.sin(angle) * radius,
      });
    });
  });

  return positions;
};
